import { FilterPillContent } from '@/features/shop/components/ProductFilter/FilterOptions/FilterPillContent'
import { CategoryFilterSection } from '@/features/shop/components/ProductFilter/CategoryFilterSection'
import { DISPLAY_FORMAT } from '@/features/shared/constants/analytics'
import { SEARCH_FILTER_TYPE } from '@/features/shared/constants/global'
import { FilterScrollWrapper } from '@/features/shop/components/ProductFilter/FilterScrollWrapper'
import { useTrackFilterUtilityClicked } from '@/features/shared/analytics/filters'
import { type SearchCategory } from '@/features/shop/services/Search/types'
import { useCurrentCategory } from '@/features/shop/components/ProductFilter/useCurrentCategory'

type Props = { name: string; index: number; items: SearchCategory[] }

export const CategoryOption = ({ name, index, items }: Props) => {
  const trackFilterUtilityClicked = useTrackFilterUtilityClicked()
  const currentCategory = useCurrentCategory()
  const pillName = currentCategory?.name || name
  const { CATEGORY } = SEARCH_FILTER_TYPE

  const handleOnClickFilter = () => {
    trackFilterUtilityClicked({
      list_index: index,
      utility_type: 'dropdown',
      filter_value: SEARCH_FILTER_TYPE.CATEGORY,
      filter_active: Boolean(currentCategory),
      display_format: DISPLAY_FORMAT.HORIZONTAL,
    })
  }

  return (
    <FilterScrollWrapper facet={CATEGORY} index={index} isDropdown>
      <FilterPillContent name={pillName} filterType={CATEGORY} onClick={handleOnClickFilter}>
        <CategoryFilterSection items={items} />
      </FilterPillContent>
    </FilterScrollWrapper>
  )
}
